export default __webpack_public_path__ + "static/media/PurpleBackgroundTopEllipse.6a972fed.svg";